export const BUTTON_URL = "https://go.referralcandy.com/share/JFTWL4Q";
export const CENTER = "center";
export const EXTRA_BOLD = "extrabold";
export const BEFORE_UNLOAD = "beforeunload";
